import React from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Link, Stack, Typography } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { JOB_PORTAL_KEYS, NS } from '../../../../../i18n/constants/keys';

interface IPrivacyNoticeContentProps {
  companyName?: string | null;
  ccaEnabled: boolean;
}

export const PrivacyNoticeContent = ({ companyName, ccaEnabled }: IPrivacyNoticeContentProps) => {
  const { t } = useTranslation(NS.jobPortal);
  const platformName = companyName || 'our platform';

  return (
    <Stack spacing={3}>
      <Stack spacing={2}>
        <Typography variant="body2">
          {t(JOB_PORTAL_KEYS.privacy.beforeLink, { companyName: platformName })}{' '}
          <Link
              href="https://www.hiacuity.com/privacy-policy"
              target="_blank"
              rel="noreferrer"
              fontWeight={700}
          >
            {t(JOB_PORTAL_KEYS.privacy.policyLink)}
          </Link>{' '}
          {t(JOB_PORTAL_KEYS.privacy.afterLink)}
        </Typography>
        <Typography variant="body2" color="text.secondary" fontStyle="italic">
          {t(JOB_PORTAL_KEYS.privacy.consentText, { companyName: platformName })}
        </Typography>
      </Stack>

      <Alert severity="success" icon={<InfoIcon fontSize="small" />}>
        <Typography variant="caption" fontWeight={800} sx={{ textTransform: 'uppercase' }} display="block" gutterBottom>
          {t(JOB_PORTAL_KEYS.details.importantNotice)}
        </Typography>
        <Stack spacing={1.5}>
          <Typography variant="body2">
            <Typography component="span" variant="body2" fontWeight={700}>
              {t(JOB_PORTAL_KEYS.details.phase1)}
            </Typography>{' '}
            {t(JOB_PORTAL_KEYS.details.phase1Text)}
          </Typography>
          <Typography variant="body2">
            <Typography component="span" variant="body2" fontWeight={700}>
              {t(JOB_PORTAL_KEYS.details.phase2)}
            </Typography>{' '}
            {t(JOB_PORTAL_KEYS.details.phase2Text)}
          </Typography>
          {ccaEnabled && (
            <Typography variant="body2" color="info.main">
              <Typography component="span" variant="body2" fontWeight={700}>
                Phase 3 - Cognitive Assessment:
              </Typography>{' '}
              Once you submit the Pre-Screening Questionnaire, we will send you
              an email invitation to complete a{' '}
              <Typography component="span" variant="body2" fontStyle="italic" fontWeight={600}>
                Cognitive Assessment (CCA)
              </Typography>
              . Please check your inbox and spam folder, then finish the
              assessment to complete your application.
            </Typography>
          )}
        </Stack>
      </Alert>
    </Stack>
  );
};
